import React from "react";
import { Container, Alert, Col } from "reactstrap";

interface IMessageProps {
  icon?: string;
  message: string;
  color?: string;
  style?: any;
}

const InfoMessage: React.FC<IMessageProps> = ({ style, icon, message, color }) => {
  return (
    <Container className="mt-5 themed-container" fluid>
      <Col sm={12} lg={{ size: 8, offset: 2 }}>
        <Alert style={style} color={color ?? "primary"} className="text-center">
          {icon && <i className={icon}></i>}
          <div className="mb-2 mt-2">
            <h2 className="text-white">{message}</h2>
          </div>
        </Alert>
      </Col>
    </Container>
  );
};

export default InfoMessage;